// extracted by mini-css-extract-plugin
export var arrow = "_3i-6";
export var changeItem = "_3i-3";
export var changesHeader = "_3i-1";
export var changesList = "_3i-2";
export var container = "_3i-0";
export var pathLabel = "_3i-4";
export var value = "_3i-7";
export var valuesContainer = "_3i-5";